module.exports = "// LoginComponent should be used as base component\n// Inherit it and provide your own template\n// Use DemoLoginComponent as an example\n";